import ReactDOM from "react-dom";
import { SignInForm } from './SignInForm';

if (document.getElementById('pdp-guest-modal')) {
  ReactDOM.render(<SignInForm />, document.getElementById('pdp-guest-modal'));
}